import React from 'react';
import styled from 'styled-components';
import { Pin1 } from '../../../../certificates-constancies/type1/info/components';
import routes from '../../../../../../../components/Routes/routingMap';
import Link from '@/presentation/reusables/Link';

const Container = styled.div`
  color: #161d1f;
  .procedure-title {
    font-weight: 700;
    line-height: 20px;
    margin-bottom: 4px;
  }
  .procedure-paragraph {
  }

  .procedure-paragraph-footer {
    margin-top: 8px;
    background-color: #eff9ff;
    border-radius: 8px;
    padding: 10px;
  }
`;

interface ProcedureInfoComponentProps {
  pin1: string;
}
const ProcedureInfoComponent = ({ pin1 }: ProcedureInfoComponentProps) => {
  const paramCoverLetter = 'TA0047';
  const { register } = routes.student.procedures.categories.tickets;

  return (
    <Container>
      <div className="procedure-title">Información del trámite</div>
      <div className="procedure-paragraph">
        La carta de presentación es un documento que le permite al estudiante
        presentarse a una empresa y participar de cualquier convocatoria
        laboral. <br />
        Revisa la información y los{' '}
        <Link
          linkType="external"
          url="https://info.utp.edu.pe/articulo/KA-01855"
          linkName="modelos de cartas pre diseñadas"
        />{' '}
        en UTP+info.
      </div>
      <br />
      <div className="procedure-title">¿Qué requisitos necesito?</div>
      <div className="procedure-paragraph">
        Ser estudiante activo o egresado de UTP.
      </div>

      <div style={{ padding: '16px 0 8px 0' }}>
        <Pin1 message={pin1} />
      </div>

      <div className="procedure-paragraph-footer">
        Si los modelos de cartas no cubren tus necesidades, puedes gestionar una
        nueva a través de{' '}
        <Link
          linkType="internal"
          url={`${register}?v=${paramCoverLetter}`}
          linkName="solicitudes SAE."
        />
      </div>
    </Container>
  );
};

export { ProcedureInfoComponent };
